var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_Logo",
    "data-name": "Controls/Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.479,
    height: 39.038,
    viewBox: "0 0 242.479 39.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5474",
    "data-name": "Group 5474",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M-262.479,25.015h6.379l4.434-6.916-3.4-4.682Z",
    transform: "translate(262.479 -0.002)",
    fill: "#4bbbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M-248.667,13.421l-6.4,0,8.416,11.592,3.246-4.319Z",
    transform: "translate(262.479 -0.002)",
    fill: "#009bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M-248.058,2.42l-6.224,9.777h6.377l4.58-7.207L-246.114.615a5.086,5.086,0,0,0-1.944,1.805",
    transform: "translate(262.479 -0.002)",
    fill: "#9f99cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M-238.476,2.607A5.227,5.227,0,0,0-241.612.2a6.887,6.887,0,0,0-4.506.415l7.391,11.589,6.385-.005s-5.514-8.623-6.134-9.59",
    transform: "translate(262.479 -0.002)",
    fill: "#52439b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M-255.087,39.038h6.379l5.663-8.079c-1.544-2.448-3-4.731-3-4.731Z",
    transform: "translate(262.479 -0.002)",
    fill: "#85c446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M-239.731,26.229h-6.31s6.473,10.228,6.589,10.406a5.413,5.413,0,0,0,1.851,1.816l2.688-4.661Z",
    transform: "translate(262.479 -0.002)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M-224.773,26.231a4.344,4.344,0,0,1-.579,2.045c-1.777,3.084-4.751,8.273-5.01,8.685a4.336,4.336,0,0,1-1.593,1.463,6.067,6.067,0,0,1-2.836.614,7.521,7.521,0,0,1-2.81-.587l7.046-12.223Z",
    transform: "translate(262.479 -0.002)",
    fill: "#0097a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M-246.647,25.009h6.4l5.237-6.994-2.939-4.6Z",
    transform: "translate(262.479 -0.002)",
    fill: "#006fba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M-224.791,25.009a5.466,5.466,0,0,0-.889-2.36l-5.892-9.234h-6.38l7.41,11.594Z",
    transform: "translate(262.479 -0.002)",
    fill: "#003e69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fullLogo",
    d: "M-208.577,6.832h2.409l10.729,22.919h-3.509L-202.134,23h-10.211l-2.992,6.75h-3.517Zm5.033,13.265-3.858-8.255-3.582,8.255Z",
    transform: "translate(262.479 -0.002)",
    fill: "#003e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-2",
    "data-name": "fullLogo",
    d: "M-174.859,6.83h3.179V29.756h-3.442V11.907l-7.357,8.811h-.636l-7.443-8.811V29.751h-3.421V6.83h3.224l7.967,9.381Z",
    transform: "translate(262.479 -0.002)",
    fill: "#003e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-3",
    "data-name": "fullLogo",
    d: "M-151.2,6.833h3.1V29.756l-2.71,0L-166.141,12.1V29.754h-3.065V6.835h2.615L-151.2,24.568Z",
    transform: "translate(262.479 -0.002)",
    fill: "#003e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M-124.609,14.3c0,4.41-2.834,7.437-8.114,7.437h-5.731v8.017H-142.8V6.834h10.078C-127.443,6.834-124.609,9.861-124.609,14.3Zm-4.38,0c0-2.383-1.384-3.735-3.927-3.735h-5.538v7.437h5.538C-130.373,18.006-128.989,16.686-128.989,14.3Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M-113.148,29.758a5.451,5.451,0,0,1-.45-2.028,6.174,6.174,0,0,1-5.344,2.414c-3.542,0-5.989-1.771-5.989-4.991,0-2.769,1.674-4.732,6.374-5.183l2.512-.225c1.545-.193,2.35-.676,2.35-1.9,0-1.289-.676-2.061-3.026-2.061-2.318,0-3.285.612-3.445,2.64h-3.993c.226-3.51,2.287-5.666,7.47-5.666,4.958,0,6.922,2,6.922,4.99V26.6a6.3,6.3,0,0,0,.676,3.156Zm-.547-6.568V21.677a3.232,3.232,0,0,1-1.9.676l-2.19.257c-2.254.258-2.994,1.063-2.994,2.383,0,1.384.934,2.253,2.8,2.253C-115.82,27.246-113.695,26.088-113.695,23.19Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M-108.413,24.477h3.959c.225,2.093,1.288,2.834,3.7,2.834,2.35,0,3.284-.741,3.284-2,0-1.192-.74-1.771-3.252-2.19l-1.9-.322c-3.573-.611-5.441-2.188-5.441-5.022,0-3.123,2.447-5.022,6.89-5.022,5.12,0,7.212,2.221,7.341,5.634H-97.66c-.1-2.126-1.417-2.737-3.51-2.737-1.964,0-2.9.741-2.9,1.931,0,1.224.967,1.707,2.769,2.03l2.093.321c3.993.709,5.764,2.189,5.764,5.055,0,3.348-2.737,5.216-7.374,5.216C-105.548,30.209-108.157,28.5-108.413,24.477Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M-92.7,24.477h3.96c.226,2.093,1.288,2.834,3.7,2.834,2.349,0,3.284-.741,3.284-2,0-1.192-.741-1.771-3.251-2.19l-1.9-.322c-3.573-.611-5.441-2.188-5.441-5.022,0-3.123,2.447-5.022,6.889-5.022,5.121,0,7.213,2.221,7.343,5.634h-3.833c-.1-2.126-1.417-2.737-3.51-2.737-1.963,0-2.9.741-2.9,1.931,0,1.224.966,1.707,2.769,2.03l2.093.321c3.993.709,5.763,2.189,5.763,5.055,0,3.348-2.737,5.216-7.372,5.216C-89.836,30.209-92.444,28.5-92.7,24.477Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M-59.732,21.451c0,5.281-2.866,8.693-7.438,8.693A5.936,5.936,0,0,1-72.32,27.6v8.469h-4.058V13.144h3.9v2.383a5.988,5.988,0,0,1,5.312-2.768C-62.6,12.759-59.732,16.172-59.732,21.451Zm-4.121-.128c0-3.51-1.642-5.216-4.283-5.216s-4.281,1.834-4.281,5.344,1.642,5.345,4.281,5.345S-63.853,24.831-63.853,21.323Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M-58.733,21.451c0-5.279,3.413-8.692,8.467-8.692s8.436,3.413,8.436,8.692-3.38,8.693-8.436,8.693S-58.733,26.732-58.733,21.451Zm12.782,0c0-3.51-1.707-5.344-4.315-5.344-2.639,0-4.313,1.834-4.313,5.344S-52.9,26.8-50.266,26.8C-47.658,26.8-45.951,24.961-45.951,21.451Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M-30.207,12.952v3.734h-1.03c-2.994,0-4.8,1.481-4.8,4.637v8.435h-4.057V13.144h3.928v2.963a5.065,5.065,0,0,1,4.958-3.22A5.152,5.152,0,0,1-30.207,12.952Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M-23.284,16.235v8.983c0,1.095.547,1.449,1.9,1.449H-20v3.091c-.741.064-1.481.129-2.125.129-3.51,0-5.184-1.192-5.184-4.25v-9.4h-2.575V13.144h2.575V8.315h4.025v4.829H-20v3.091Z",
    transform: "translate(262.479 -0.002)",
    fill: "#6639b7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsLogo);
export default __webpack_public_path__ + "static/media/Controls-Logo.b3cace551c5c69497622bb83a1d19ae3.svg";
export { ForwardRef as ReactComponent };